<div class="container">
    <div style="margin-bottom: 20px;">
        <span style="font-size: 24px;" [ngStyle]="{'color': owner.data.color}">{{owner.data.name}}</span> is the room owner.
    </div>
    @for (user of users; track $index) {
    <div class="user">
        <span class="name" [ngStyle]="{'color': user.data.color}">{{user.data.name}}</span>
        <span class="referee interactable" (click)="toggleReferee(user.id)">{{user.data.referee ? 'Referee' : 'Attendee'}}</span>
        <span class="coordinates interactable" (click)="goThere(user.id)">{{ renderPosition(user.data.view.position) }}<button (click)="bringHere($event, user.id);">🔁</button></span>
        @if (user.id !== owner.id) {<span class="remove interactable" (click)="removeUser(user.id)">🗑</span>}
    </div>
    }
</div>